import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/(authentication)/admin-login')({
    component: AdminLogin,
});

function AdminLogin() {
    return (
        <PageController route={Route}>
            <Navigate to="/login" />
        </PageController>
    );
}
